import { Component, Input, inject } from '@angular/core';
import { customCard } from 'src/app/shared/model/customCard';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-climate-projects',
  templateUrl: './climate-projects.component.html',
  styleUrl: './climate-projects.component.scss',
  standalone: false,
})
export class ClimateProjectsComponent {
  @Input() cardslist!: customCard[];

  private translocoService = inject(TranslocoService);

  cardsList: customCard[] = [
    {
      icon: '/assets/icons/blue-folder-bg.svg',
      title: this.translocoService.translate('ressources.projectSheets'),
      link: 'home/ressources',
    },
    {
      icon: '/assets/icons/blue-folder-bg.svg',
      title: this.translocoService.translate('ressources.projectPictures'),
      link: 'home/ressources',
    },
    {
      icon: '/assets/icons/blue-folder-bg.svg',
      title: this.translocoService.translate('ressources.projectVideos'),
      link: 'home/ressources',
    },
    {
      icon: '/assets/icons/blue-folder-bg.svg',
      title: this.translocoService.translate('ressources.projectReports'),
      link: 'home/ressources',
    },
    {
      icon: '/assets/icons/blue-folder-bg.svg',
      title: this.translocoService.translate('ressources.customCommunication'),
      link: 'home/ressources',
    },
  ];
}
